import { useCallback, useRef, useState } from 'react';

import { StoredDeviceLog } from '../interfaces';
import { getOnboardDeviceLogs } from '../api/getOnboardDeviceLogs';

export const useStoredOnboardDeviceLogs = (deviceId: string, onError: (message: string) => void) => {
    const [storedLogs, setStoredLogs] = useState<StoredDeviceLog[]>([]);
    const [loading, setLoading] = useState(false);

    // Held in a ref so loadStoredLogs keeps a stable identity: the effect that
    // calls it runs on every render otherwise.
    const onErrorRef = useRef(onError);
    onErrorRef.current = onError;

    const loadStoredLogs = useCallback(async () => {
        try {
            setLoading(true);
            const response = await getOnboardDeviceLogs(deviceId);
            setStoredLogs(response.logs ?? []);
        } catch (error: any) {
            console.error('Stored logs error:', error);
            const message = error?.response?.data?.message ?? 'Не вдалося отримати список логів у хмарі';
            onErrorRef.current(message);
        } finally {
            setLoading(false);
        }
    }, [deviceId]);

    // A sync reloads this list every time a log becomes downloadable, so the
    // spinner is only for the first load - otherwise the grid would flicker
    // under the user while rows are being added to it.
    return { storedLogs, storedLogsLoading: loading && storedLogs.length === 0, loadStoredLogs };
};
